function menuToggle(){
    document.querySelectorAll('.menu-top .submenu-toggle, .menu-header .submenu-toggle').forEach(submenuToggle => {
        submenuToggle.addEventListener('click', (event) => {
            event.preventDefault(); // при клике на ссылку никуда не переходим
        });

        submenuToggle.addEventListener('keydown', (event) => {
            if(event.which === 13) {
                event.preventDefault();
                event.target.nextElementSibling.slideToggle(200); // при нажатии на enter разворачиваем подразделы
            }
        });
    });
}

export default menuToggle;